/**
 * Custom accordion functionality
 *
 * @since   1.0.0
 * @package mel
 */

(function($) {
	$(document).ready(function() {

		// toggle active classes on click
		$('.accordion-single').click(function() {

			$( '.accordion-single' ).removeClass( 'active' );
			$( '.accordion-content' ).slideUp( 'normal' );

			if ($(this).find( '.accordion-content' ).is( ':hidden' ) == true) {

				// add active class to accordion tab
				$(this).addClass('active');

				// reveal content
				$(this).find( '.accordion-content' ).slideDown( 'normal' );
			}

		});
		$( '.accordion-content' ).hide();

		// add active class if matching #id is in 
		if( window.location.hash ) {
			// reveal tab associated with matching id/hash
			var target = window.location.hash;

			if ( target != '' ){
				var $target = jQuery( target ); 
				jQuery('html, body').stop().animate({
					'scrollTop': $target.offset().top - 100},
					900, 
					'swing',function () {
						window.location.hash = target - 100 ;
					});
			}

			$( target ).find( '.accordion-title' ).addClass( 'active' );
			$( target ).find( '.accordion-content' ).slideDown( 'normal' );
		}

	}); // document.ready
})(jQuery);
